module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"vacancy":"Вакансия"}}')
  delete Component.options._Ctor
}
